// extracted by mini-css-extract-plugin
module.exports = {"ApplicantNoteCard":"ApplicantNoteCard_ApplicantNoteCard__1SPk2","NoteOptionsPopup":"ApplicantNoteCard_NoteOptionsPopup__1ftpJ"};